import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../models/types';

interface QueryExplorerVars {
  queryId: string;
}

const GQL_DESCRIBE_QUERY_ID = gql`
  query describeQueryId($queryId: String!) {
    describeQueryId(queryId: $queryId)
  }
`;

export const useQueryExplorerQuery = () => {
  return useLazyQuery<AnyObject, QueryExplorerVars>(GQL_DESCRIBE_QUERY_ID, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });
};
